export default __webpack_public_path__ + "static/media/Attention and Focus.7afd1630.png";